import PracticePlay from './model';
import create from './create';

PracticePlay.create = create;

export default PracticePlay;



// WEBPACK FOOTER //
// ./data/PracticePlay/model/index.js